import React,{useEffect,useState} from 'react';
import {collectVersions} from './collectVersions.js';

export default function ResolutionForm({term,comment,api,saving,onSubmit}){
 const [conclusion,setConclusion]=useState(comment.conclusion||'');
 const [version,setVersion]=useState(String(comment.resolutionVersion||''));
 const [versions,setVersions]=useState([]),[error,setError]=useState(''),[loading,setLoading]=useState(true),[retry,setRetry]=useState(0);
 useEffect(()=>{let active=true;setLoading(true);setError('');
  api('terms/'+encodeURIComponent(term.id)+'/history?revisions=all').then(events=>{if(active)setVersions(collectVersions(term,events));}).catch(e=>{if(active)setError(e.message);}).finally(()=>{if(active)setLoading(false);});
  return()=>{active=false;};
 },[term.id,term.version,retry]);
 return <form className="resolve-form" onSubmit={e=>{e.preventDefault();if(!saving)onSubmit(conclusion,version?Number(version):null);}}>
  <label htmlFor="conclusion">結論與理由</label><textarea id="conclusion" required maxLength={10000} rows={5} value={conclusion} onChange={e=>setConclusion(e.target.value)} placeholder="採用什麼方向？原因是什麼？"/>
  <label htmlFor="resolution-version">對應修改（選填）</label>
  <select id="resolution-version" value={version} disabled={loading||Boolean(error)} onChange={e=>setVersion(e.target.value)}>
   <option value="">不連結版本</option>{versions.map(v=><option key={v.version} value={v.version}>第 {v.version} 版{v.version===term.version?' · 最新':''}{v.updatedBy?.name?' · '+v.updatedBy.name:''}</option>)}
  </select>
  {loading&&<p role="status">載入版本…</p>}{error&&<p role="alert">無法載入版本：{error} <button type="button" onClick={()=>setRetry(n=>n+1)}>重試</button></p>}

  <button className="primary" disabled={saving||!conclusion.trim()}>{saving?'儲存中…':'儲存暫定結論'}</button>
 </form>;
}
